import { getV1UsersMeAccess } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import { Access } from '~hooks/useAccess/models';
import connection from '~services/connectionModule';
import { useStores } from '~store';

export default function useAccess() {
  const { userStore } = useStores();

  const getAccess = async () => {
    try {
      const response = await getV1UsersMeAccess();
      const formatted = response.data.data.map(Access.parse);

      userStore.setAccess(formatted);

      return formatted;
    } catch (error) {
      connection.handleRequestError(error, t('error_messages.access.failed_to_fetch'));
    }
  };

  return { getAccess };
}
